import React from "react";
import { useContactGroupsQuery } from "../queries";

export const withContactGroups = () => (BaseComponent) => (props) => {
  const query = useContactGroupsQuery();
  if (query.isLoading) return null;
  return <BaseComponent {...props} contactGroups={query.data} />;
};
